/**
 * experiments/tests/clipping.js
 *
 * A central location to house all experiments related to clipping. This file is currently
 * included in the combined_experiments.js package.
 */
;(function (win) {
  let Experiments = win.slideshare_object.utils.imports("Experiments"),
    experiments = new Experiments()

  // TODO: remove this clean up code
  // Delete previous versions of the Clip button experiment
  experiments.deleteExperiment("slideview-clip-button")
  experiments.deleteExperiment("slideview-clip-button-exp-2")
  experiments.deleteExperiment("slideview-clip-button-exp-3")
})(window)
